export function scrollDown() {
    $(".scroll-down").on("click", function () {
        $('html, body').animate({
            scrollTop: $(this).parent().innerHeight() - $('.header').innerHeight()
        }, 700);
        return false;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollDown.js